<template>
	<div class="component-layout-footer-service">
		<a-row class="list">
			<a-col class="item">
				<router-link to="/about" class="text">平台資訊</router-link>
			</a-col>
			<a-col class="item">
				<router-link to="/user_knowhow" class="text">使用者專區</router-link>
			</a-col>
			<a-col class="item">
				<router-link to="/legal_policy" class="text">法律與政策</router-link>
			</a-col>
			<a-col class="item">
				<router-link to="/product_return" class="text">退換貨須知</router-link>
			</a-col>
			<a-col class="item">
				<router-link to="/contact_info" class="text">社群/聯絡</router-link>
			</a-col>
		</a-row>
		
		<hr />

		<div class="copyright">
			Copyright <span>Dalampa媒合</span> All Rights Reserved.
		</div>
	</div>
</template>

<script>
	import './service.scss';

	export default {
		name: 'Service',
	}
</script>